import ImageModel from '@/models/image.model';

export default interface CommentModel {
  id: string;
  badge: USER_ROLE;
  user: CommentUserModel;
  createdAt: number;
  status: COMMENT_STATUS;
  description: string;
  currentUserVote?: 'like' | 'dislike';
}

export interface CommentUserModel {
  id: string;
  avatar: ImageModel;
  displayName: string;
}

export enum USER_ROLE {
  VENDOR = 'vendor',
  CUSTOMER = 'customer',
  ADMIN = 'administrator',
  SUPPORT = 'support_team',
}

export enum COMMENT_STATUS {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
}
